import { Provider, Type } from '@angular/core';
import { ListViewDataBase } from '@examdojo/core/list-view';
import { GridOptions } from 'ag-grid-community';
import { ListViewColDef } from './list-view.model';

export abstract class AbstractSimpleAgGridService<Model = ListViewDataBase> {
  abstract readonly gridOptions: GridOptions<Model>;
  abstract readonly columnDefs: Array<ListViewColDef<Model>>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function provideAgGridService(listViewService: Type<AbstractSimpleAgGridService<any>>): Provider[] {
  return [
    listViewService,
    {
      provide: AbstractSimpleAgGridService,
      useExisting: listViewService,
    },
  ];
}
